<template>
  <div>
    <leave-code-add-new
        :is-add-new-leave-code-sidebar-active.sync="isAddNewLeaveCodeSidebarActive"
        :id = "id"
        :data="leavecodeData"
        @refetch-data="refetchData"
        v-if="ability.can('create','leavecodes')"
    >

    </leave-code-add-new>

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
              <b-button
                variant="primary"
                @click="handleCreate"
              >
                <span class="text-nowrap">Add Leave Code</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

    <b-table
        ref="refLeaveCodeListTable"
        class="position-relative"
        :items="fetchLeaveCodes"
        responsive
        stacked="md"
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
    >
    <template #cell(count_al_balance)="data">
        <feather-icon 
        v-if="data.item.count_al_balance"
        icon="CheckIcon"
        size="18"
        class="mr-50 text-success"
        />
    </template>

    <template #cell(reason_bit)="data">
      <feather-icon
        v-if="data.item.reason_bit"
        icon="CheckIcon"
        size="18"
        class="mr-50 text-success"
      />
    </template>


    <template #cell(action)="data">
        <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item v-if="ability.can('update','leavecodes')" @click="handleEdit(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
          </b-dropdown>
    </template>
    </b-table>  
    <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalLeaveCodes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import leavecodeStoreModule from "../leavecodeStoreModule";
import useLeaveCodesList from "./useLeaveCodesList";
import LeaveCodeAddNew from "./LeaveCodeListAddNew.vue"

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    LeaveCodeAddNew,
  },
  methods:{
      handleCreate(){
          this.id = 0
          this.resetLeaveCodeData()
          this.isAddNewLeaveCodeSidebarActive = true
      },
      handleEdit(item){
        this.id = item.id
        this.leavecodeData.id = item.id
        this.leavecodeData.leave_code = item.leave_code
        this.leavecodeData.description = item.description
        this.leavecodeData.remark = item.remark
        this.leavecodeData.reason_bit = item.reason_bit
        this.leavecodeData.count_al_balance = item.count_al_balance
        this.isAddNewLeaveCodeSidebarActive = true
        
      }, resetLeaveCodeData(){
        this.leavecodeData = {
            id: 0,
            leave_code: '',
            description: '',
            remark: '',
            reason_bit: false,
            count_al_balance:false,
        }
      }
  },
  data(){
    return {
        id:0,
        leavecodeData:{},
    }  
  },
  setup() {
    const SETTING_LEAVE_CODE_STORE_MODULE_NAME = "setting-leavecode";

    if (!store.hasModule(SETTING_LEAVE_CODE_STORE_MODULE_NAME))
      store.registerModule(
        SETTING_LEAVE_CODE_STORE_MODULE_NAME,
        leavecodeStoreModule
      );

    onUnmounted(() => {
      if (store.hasModule(SETTING_LEAVE_CODE_STORE_MODULE_NAME))
        store.unregisterModule(SETTING_LEAVE_CODE_STORE_MODULE_NAME);
    });

    const isAddNewLeaveCodeSidebarActive = ref(false);

    const {
      fetchLeaveCodes,
      tableColumns,
      perPage,
      currentPage,
      totalLeaveCodes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refLeaveCodeListTable,
      refetchData,
      ability,
    } = useLeaveCodesList();

    return {
      //Sidebar
      isAddNewLeaveCodeSidebarActive,

      fetchLeaveCodes,
      tableColumns,
      perPage,
      currentPage,
      totalLeaveCodes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refLeaveCodeListTable,
      refetchData,
      avatarText,
      ability,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>